import React, { useEffect, useState } from 'react';
import { getCurrentAdmin } from './auth';
import type { AdminUser } from './types';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';

export default function AdminPortal() {
  const [admin, setAdmin] = useState<AdminUser | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Add noindex meta tag for admin pages
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow,noarchive,nosnippet';
    document.head.appendChild(meta);

    const a = getCurrentAdmin();
    setAdmin(a);
    setChecking(false);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin" />
          <span className="text-sm text-slate-500">Loading...</span>
        </div>
      </div>
    );
  }

  if (!admin) {
    return <AdminLogin onLoginSuccess={() => setAdmin(getCurrentAdmin())} />;
  }

  return <AdminDashboard />;
}
